import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { faBars, faChevronRight, faTimes} from '@fortawesome/free-solid-svg-icons';
import { SessionService} from '../../services/session.service'
import { Router, ActivatedRoute} from '@angular/router';
import { gutil} from '../../gutil';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as moment from 'moment';
import { MapsAPILoader } from '@agm/core';


declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {

  public faBars = faBars;
  public faTimes = faTimes;
  public faRight = faChevronRight;
  public user : any;
  public citySel:Array<any>;
  public genderSel:Array<any>;
  public propType:Array<any>;
  public cityName:any;
  public gender:any;
  public getDate:any;
  public tenantChoice:any; 
  public minOwnerDate:any;
  public devMinDate:any;
  public notf_msg:boolean = false;
  public dispMsg:string;
  public schlVisit = { visitorname: "", phone: "", email:"", locality:"", city:"" };
  public visitorFname:string;
  public visitorLname:string;
  public email_re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public phone_re = /\+?\d[\d -]{8,12}\d/;
  public selectedLoc:any;
  public selectedUserType : string;
  public bcmOwner = {ownername: "", email:"",phone:"",address:"",city:"",startdate:"", otherreq:"", specs:"",expectations:"",tenantType:"",rentalprog:"", serviceType:""};
  public srReqTypesSel:Array<any>;
  public pmsProg:boolean = false;
  public rentalPmsProg:boolean = true;
  public ownerlastname = "";
  public ownerfirstname = "";
  public success_msg:boolean = false;
  public bcmDeveloper = {firstname: "", lastname:"", email:"",phone:"",address:"",zipcode:"",specs:"",expectations:"",tenantType:"",rentalprog:""};
  public userInitials : string ;

  @ViewChild("locality")
  public searchElementRef3: ElementRef;

  constructor(private sessionservice : SessionService , private router : Router, private http: HttpClient, private mapsAPILoader: MapsAPILoader , private actroute : ActivatedRoute) {
    if(gutil.user != undefined){
      this.user = gutil.user;
    }
    this.citySel = gutil.citySel;
    this.genderSel = gutil.genderSeluser;
    this.propType = gutil.houseType;
  }

  ngOnInit() {
    this.minOwnerDate = moment().add(1, 'days').format("YYYY-MM-DD");
    this.devMinDate = moment().add(1, 'days').format("YYYY-MM-DD");
    this.fetchAutoComplete(12.972442, 77.580643);
    this.schlVisit.city = 'city';
    this.bcmOwner.tenantType = "tenant_type";
    this.srReqTypesSel = gutil.srTypesSel;
    this.citySel = gutil.citySel;
    this.bcmOwner.serviceType = "0";
    this.bcmOwner.city = "city";
    this.bcmOwner.rentalprog = 'rentalandpms';
    this.bcmOwner.startdate = "Select Date";
    this.bcmDeveloper.tenantType = "tenant_type";
    this.tenantChoice = gutil.houseType;
    // this.selectedUserType = localStorage.getItem("selectedCustType");
    if(this.router.url.indexOf('home') > -1){
      this.selectedUserType = '1';
    }
    else if(this.router.url.indexOf('becomeanowner') > -1){
      this.selectedUserType = '2';
    }else if(this.router.url.indexOf('developerlanding') > -1){
      this.selectedUserType = '3';
    }else{
      this.selectedUserType = '1';
    }
  }
  login(){
    this.router.navigate(['/login']);
  }
  logoutSubmit(){
    this.sessionservice.logout();
    
    this.router.navigate(['/login']);
  }
  dashboard(role: number){
    if(role == 2){
      this.router.navigate(['/profile/owner']);
    }
    if(role == 1){
      this.router.navigate(['/profile/tenant']);
    }
  }
  

  public schVisit(){
    $("#schVisModal").modal('show');
  }
  public changeFirstName(value:any) {
    this.visitorFname = value;
  }
  public changeLastName(value:any) {
    this.visitorLname = value;
  }
  public changePhone(value:any) {
    this.schlVisit.phone = value;
  }
  public changeEmail(value:any) {
    this.schlVisit.email = value;
  }
  public changeLocality(value:any) {
    this.schlVisit.locality = value;
  }
  public changeCity(value:string) {
    this.schlVisit.city = value;
    gutil.searchData.city = value;
    if(value == 'pune'){
      this.fetchAutoComplete(18.5204, 73.8567);
    }else{
      this.fetchAutoComplete(12.972442, 77.580643);
    }
  }
  public onSubmitVisit() {
    if(this.visitorFname != "" && this.visitorLname !="" && this.schlVisit.phone !="" && this.schlVisit.email != "" && this.selectedLoc !="") {
      if(this.email_re.test(this.schlVisit.email)) {
        if(this.phone_re.test(this.schlVisit.phone)) {
          this.fetchForm();
          this.notf_msg = true;
          // this.dispMsg = "Form  submitted successfully!";
          this.closeNotfs();
          this.clearForm();
        } 
        else {
          this.notf_msg = true;
          this.dispMsg = "Invalid Phone number";
          this.closeNotfs();
        }
      }
      else {
        this.notf_msg = true;
        this.dispMsg = "Invalid Email";
        this.closeNotfs();
      }
    }
    else {
      this.notf_msg = true;
      this.dispMsg = "Please fill the details!";
      this.closeNotfs();
    }
    
  }
  public fetchForm() {
    this.schlVisit.visitorname = this.visitorFname + " " + this.visitorLname;
    let headers = new HttpHeaders({'Accept': 'application/json'});
    let options =  {headers: headers }; 
    let params = new URLSearchParams();

    for(let sc in this.schlVisit) {
      params.append(sc, this.schlVisit[sc]);
    }
    let paramsString = params.toString();
    gutil.searchData.address = this.selectedLoc;
    var loc = this.selectedLoc.substring(0 , this.selectedLoc.indexOf(",")).replace(" ",'-');
    this.router.navigate(['/' + gutil.searchData.city + '/properties-for-rent/'+ loc]);
    $("#schVisModal").modal('hide');
  }
  public closeNotfs() {
    setTimeout(() => {
      this.notf_msg =false;
    }, 3000);
  }
  public fetchAutoComplete($lat:any,$lon:any){
    this.mapsAPILoader.load().then(() => {
      let defaultBounds: google.maps.LatLngBounds ;
      let options: google.maps.places.AutocompleteOptions;
      
      
      defaultBounds= new google.maps.LatLngBounds(
        new google.maps.LatLng($lat , $lon),
        new google.maps.LatLng($lat , $lon)
      );
      options = {
        bounds : defaultBounds,
        componentRestrictions : {country : 'in'}
      };
      let autocomplete3 = new google.maps.places.Autocomplete(this.searchElementRef3.nativeElement , options);
      autocomplete3.addListener("place_changed", () => {
        this.selectedLoc = autocomplete3.getPlace().formatted_address;
      })
    })
  
   }
  public clearForm() {
    this.visitorFname = "";
    this.visitorLname = "";
    this.schlVisit.city = "";
    this.schlVisit.phone = "";
    this.schlVisit.locality = "";
    this.schlVisit.email = "";
    this.schlVisit.visitorname = "";
  }

  public selectUserType(type : string){
    
    this.selectedUserType = type;    
    if(type == '1'){
      this.router.navigate(['/tenant']);
    }else if(type == '2'  ){
      this.router.navigate(['/becomeanowner']);
    }else if(type == '3'){      
      this.router.navigate(['/developerlanding'])
    }
    else{
      this.router.navigate(['']);
    }
  }
////////////////////////////////////////////////////////Owner Form /////////////////////////////////////
public changeOwnerFirstName(value:any) {
  this.ownerfirstname = value;
}
public changeOwnerLastName(value:any) {
  this.ownerlastname = value;
}
public changeOwnerEmail(value:any) {
  this.bcmOwner.email = value;
}
public changeOwnerPhone(value:any) {
  this.bcmOwner.phone = value;
}
public changeOwnerAddress(value:any) {
  this.bcmOwner.address  = value;
}
public changeOwnerPropSpecs(value:any) {
  this.bcmOwner.specs = value;
}
public cityOwnerChange(value:any) {
  this.bcmOwner.city = value;
}
public changeOwnerCommExp(value:any) {
  this.bcmOwner.expectations = value;
}
public changeOwnerTenType(value:any) {
  this.bcmOwner.tenantType = value;
}
public changeOwnerServiceType(value:any) {
  this.bcmOwner.serviceType = value;
}
public changeOwnerOtherReqs(value:any) {
  this.bcmOwner.otherreq = value;
}
public changeOwnerStartDate(value:any) {
}
public changeOwnerRentalProgram(value:any) {
  this.bcmOwner.rentalprog = value;
  if(this.bcmOwner.rentalprog == 'rentalandpms') {
    this.rentalPmsProg = true;
    this.pmsProg = false;
  }
  else if(this.bcmOwner.rentalprog == 'pms'){
    this.pmsProg = true;
    this.rentalPmsProg = false;
  }
}
  public beOwner() {
    $("#ownerModal").modal('show');
  }
  public postOwnerForm() {
    if(this.ownerfirstname !="" && this.ownerlastname != "" && this.bcmOwner.phone !="" && this.bcmOwner.email !="") {
      if(this.email_re.test(this.bcmOwner.email)) {
        if(this.phone_re.test(this.bcmOwner.phone)) {
          this.postForm();
        }
        else {
          this.notf_msg = true;
          this.dispMsg = "Invalid Phone number!";
          this.closeNotfs();
        }
      }
      else {
        this.notf_msg = true;
        this.dispMsg = "Invalid Email!";
        this.closeNotfs();
      }
    }
    else {
      this.notf_msg = true;
      this.dispMsg = "Please fill the form";
      this.closeNotfs();
    }
  }
  public postForm() {
      let headers = new HttpHeaders({'Accept': 'application/json'});
      let options =  {headers: headers }; 
      let params = new URLSearchParams();
      this.bcmOwner.ownername = this.ownerfirstname + " " + this.ownerlastname;
      for(let ow in this.bcmOwner) {
        params.append(ow, this.bcmOwner[ow]);
      }
      let paramsString = params.toString(); 
      this.http.post(gutil.devapiUrl + '/api/w/v1/lead/ownerproperty/add',paramsString, options)
          .subscribe((data:any) => {
            this.success_msg = true;
            this.dispMsg = "Form submitted successfully!";
            this.closeNotfs();
            this.clearOwnerForm();
            setTimeout(() => {
              $('#ownerModal').modal('hide');
            }, 2000)
            
          })
  }
  public clearOwnerForm() {
    this.ownerfirstname = "";
    this.ownerlastname = "";
    this.bcmOwner.email = "";
    this.bcmOwner.phone = "";
    this.bcmOwner.address = "";
    this.bcmOwner.specs = "";
    this.bcmOwner.expectations = "";
    this.bcmOwner.tenantType = "tenant_type";
    this.bcmOwner.serviceType = "0";
    this.bcmOwner.otherreq = "";
    this.bcmOwner.city = "city";
    this.bcmOwner.rentalprog = 'rentalandpms';
    setTimeout(() => {
      this.success_msg = false;
    }, 2000)
  }
/////////////////////////////////////////////////Developer Form /////////////////////////////////////////////
  public beDeveloper() {
    $("#developerModal").modal('show');
  }
  
public changeDevFirstName(value:any) {
  this.bcmDeveloper.firstname = value;
}
public changeDevLastName(value:any) {
  this.bcmDeveloper.lastname = value;
}
public changeDevEmail(value:any) {
  this.bcmDeveloper.email = value;
}
public changeDevPhone(value:any) {
  this.bcmDeveloper.phone = value;
}
public changeDevAddress(value:any) {
  this.bcmDeveloper.address  = value;
}
public changeDevZip(value:any) {
  this.bcmDeveloper.zipcode = value;
}
public changeDevPropSpecs(value:any) {
  this.bcmDeveloper.specs = value;
}
public changeDevCommExp(value:any) {
  this.bcmDeveloper.expectations = value;
}
public changeDevTenType(value:any) {
  this.bcmDeveloper.tenantType = value;
}
public changeDevRentalProgram(value:any) {
  this.bcmDeveloper.rentalprog = value;
}

public submitDevForm() {
  if(this.bcmDeveloper.firstname != "" && this.bcmDeveloper.lastname != "" && this.bcmDeveloper.email !="" && this.bcmDeveloper.phone !=""
      && this.bcmDeveloper.rentalprog != "") {
        if(this.email_re.test(this.bcmDeveloper.email)) {
          if(this.phone_re.test(this.bcmDeveloper.phone)) {
            this.success_msg = true;
            this.dispMsg =  "Form submitted successfully";
            this.closeNotfs();
            this.clearDevForm();
            setTimeout(() => {
              $('#developerModal').modal('hide');
            }, 3000)
          } 
          else {
            this.notf_msg = true;
            this.dispMsg =  "Invalid Phone number";
            this.closeNotfs();
          }
        }
        else {
          this.notf_msg = true;
          this.dispMsg = "Invalid Email";
          this.closeNotfs();
        }
  }
  else {
    this.notf_msg = true;
    this.dispMsg = "Please select your requirement!";
    this.closeNotfs();
  }
}
  public clearDevForm() {
    this.bcmDeveloper.firstname = "";
    this.bcmDeveloper.lastname = "";
    this.bcmDeveloper.email = "";
    this.bcmDeveloper.phone = "";
    this.bcmDeveloper.address = "";
    this.bcmDeveloper.zipcode = "";
    this.bcmDeveloper.specs = "";
    this.bcmDeveloper.expectations = "";
    // this.bcmDeveloper.tenantType = "";
    this.bcmDeveloper.rentalprog = "";
    setTimeout(() => {
      this.success_msg = false;
    }, 2000)
  }
  

}